import { render, staticRenderFns } from "./PopupDialogBase.vue?vue&type=template&id=2356f6f1"
import script from "./PopupDialogBase.vue?vue&type=script&lang=js"
export * from "./PopupDialogBase.vue?vue&type=script&lang=js"
import style0 from "./PopupDialogBase.vue?vue&type=style&index=0&id=2356f6f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports